import {ChildPortChunk} from "../../chunks/types/ChildPortChunk";
import {PortDirection} from "../types/PortDirection";
import {getPortDirectionFromChildPortDirectionChunk} from "./getPortDirectionFromChildPortDirectionChunk";

export function getPortDirectionFromChildPortChunk(
  childPortChunk: ChildPortChunk
): PortDirection {
  const {
    captures: {
      2: childPortDirectionChunk
    }
  } = childPortChunk;
  return getPortDirectionFromChildPortDirectionChunk(childPortDirectionChunk);
}
